import * as React from 'react';

import {InlineTab} from '../tabs/inline-tabs/inline-tab';
import {InlineTabs} from '../tabs/inline-tabs/inline-tabs';

import styles from './customize-modal-tabs.module.css';

type ContentType = 'SELECT' | 'ORDER';

type Props = {
    selectedTab: ContentType;
    onChange: (selectedTab: ContentType) => void;
    selectedCount: number;
    limit: number | null | undefined;
};

export function CustomizeModalTabs(props: Props) {
    const count = props.limit ? `${props.selectedCount}/${props.limit}` : undefined;
    const isOverLimit = props.limit && props.selectedCount > props.limit;

    return (
        <div className={styles['tab-container']}>
            <InlineTabs
                name='configureModal'
                selectedTab={props.selectedTab}
                onChange={props.onChange}
            >
                <InlineTab value='SELECT'>
                    <span className={styles.tab}>
                        Choose fields
                        {props.selectedCount && props.limit ? (
                            <div className={styles.count}>
                                (
                                <span
                                    className={
                                        isOverLimit ? styles['count--over-limit'] : undefined
                                    }
                                >
                                    {count}
                                </span>
                                )
                            </div>
                        ) : null}
                    </span>
                </InlineTab>
                <InlineTab value='ORDER'>
                    <span className={styles.tab}>Re-order fields</span>
                </InlineTab>
            </InlineTabs>
        </div>
    );
}
